import React from "react";
import { Redirect } from "react-router";

import * as PATH from "consts/routePaths";
import SignInContainer from "edu_lms/modules/SignIn/container";
import SignUpContainer from "edu_lms/modules/SignUp/container";
import ForgotPasswordContainer from "edu_lms/modules/ForgotPassword/container";
import NotFoundContainer from "edu_lms/modules/NotFound/containers";
import TutorialContainer from "edu_lms/modules/Tutorial/container";
import UpdateInformationContainer from "edu_lms/modules/UpdateInformation/container";
import BookDetailContainer from "edu_lms/modules/BookDetail/container";
import ProgrammerContainer from "edu_lms/modules/ProgrammeGDPT/contatiner";
import IntroduceContainer from "edu_lms/modules/Introduce/contatiner";
import EducationTeacherContainer from "edu_lms/modules/EducationTeacher/contatiner";
import JobContainer from "edu_lms/modules/Job/container";
import VerifyOtpPwContainer from "edu_lms/modules/VerifyOtpPw/container";
import ChangePwContainer from "edu_lms/modules/ChangePw/container";
import ContactContainer from "edu_lms/modules/Contact/container";
import TermsOfUseContainer from "edu_lms/modules/TermsOfUse";
import PrivacyPolicyContainer from "edu_lms/modules/PrivacyPolicy";
import ReadingBooksContainer from "edu_lms/modules/ReadingBooks/containers";
import BookIntroduceContainer from "edu_lms/modules/BookInstruction/container";
import TrainingTestContainer from "edu_lms/modules/TrainingTest/containers";
import ListQuizContainer from "edu_lms/modules/ListQuiz/containers";
import ListQuizDetailContainer from "edu_lms/modules/ListQuizDetail/containers";
import DashboardContainer from "edu_lms/modules/Dashboard/container";
import AdminGradeContainer from "edu_lms/modules/Dashboard/Page/AdminGrade/container";
import AdminStudentContainer from "edu_lms/modules/Dashboard/Page/AdminStudent/container";
import AdminTeacherContainer from "edu_lms/modules/Dashboard/Page/AdminTeacher/container";
import AdminDepartmentEducationContainer from "edu_lms/modules/Dashboard/Page/AdminDepartmentEducation/container";
import AdminSchoolContainer from "edu_lms/modules/Dashboard/Page/AdminSchool/container";
import Dashboard from "edu_lms/modules/Dashboard/components/Dashboard";
import ResultQuizProvinceContainer from "edu_lms/modules/Dashboard/Page/ResultQuizProvince/container";
import ResultQuizDistrictContainer from "edu_lms/modules/Dashboard/Page/ResultQuizDistrict/container";
import ResultQuizSchoolContainer from "edu_lms/modules/Dashboard/Page/ResultQuizSchool/container";
import ResultQuizTeacherContainer from "edu_lms/modules/Dashboard/Page/ResultQuizTeacher/container";
import ResultQuizDetailContainer from "edu_lms/modules/Dashboard/Page/ResultQuizDetail/container";
import AdminDetailContainer from "edu_lms/modules/Dashboard/Page/AdminDetail/container";
import SlideLibraryContainer from "edu_lms/modules/SlideLibrary/container";
import ReadingSlideLibraryContainer from "edu_lms/modules/ReadingSlideLibrary/containers";
import QuestionContainer from "edu_lms/modules/Question/container";
import ExerciseContainer from "edu_lms/modules/DoingExercise/container";
import Home from "edu_lms_v2/modules/Home/index";

import Register from "edu_lms_v2/modules/Register";
import UpdateInformation from "edu_lms_v2/modules/UpdateInformation";
import PrivacyPolicy from "edu_lms_v2/modules/Contacts";
import Setting from "edu_lms_v2/modules/Setting";
import BookIntro from "edu_lms_v2/modules/BookIntro";
import Intro from "edu_lms_v2/modules/Intro";
import SliderLibrary from "edu_lms_v2/modules/SlideLibrary/index";
import OnePercentIntro from "edu_lms_v2/modules/OnePercentIntro";
import Student from "edu_lms_v2/modules/Student";
import Teacher from "edu_lms_v2/modules/Teacher";
import ReadingSlide from "edu_lms_v2/modules/ReadingSlide";
import LoginPage from "edu_lms_v2/modules/Login/LoginPage";
import FrequentQuestion from "edu_lms_v2/modules/FrequentQuestion";
import Term from "edu_lms_v2/modules/Term";
import Privacy from "edu_lms_v2/modules/Privacy";
import { menu } from "edu_lms_v2/data/guide";
import Notification from "edu_lms_v2/modules/Notification";
import QuestionSetWrapper from "edu_lms_v2/modules/ControlDoingExercise";
import { ListStudentDoingHomeWork } from "edu_lms_v2/modules/TeachingManager/ListStudentDoingHomeWork/ListStudentDoingHomeWork";
import TeacherExerciseList from "edu_lms_v2/modules/TeachingManager/ClassroomManager/ExerciseClassroom/ListExercise";
import StudentDoingExercise from "edu_lms_v2/modules/Student/DoingExercise";
import StudentDoingExercise2 from "edu_lms_v2/modules/Student/DoingExercise2";
import StudentDoingExercise3 from "edu_lms_v2/modules/Student/Doingexercise3";
import StudentDoingExercise4 from "edu_lms_v2/modules/Student/DoingExercise4";
import StudentDoingExercise5 from "edu_lms_v2/modules/Student/DoingExercise5";
import StudentDoingExercise6 from "edu_lms_v2/modules/Student/DoingExercise6";
import QuestionLibraryV2 from "edu_lms_v2/modules/QuestionLibraryV2";
import ResultQuestion from "edu_lms_v2/modules/MockTest/ResultQuestion";
import MockTest2 from "edu_lms_v2/modules/MockTest/MockTest2";
import MockTest from "edu_lms_v2/modules/MockTest";
import ListExerciseResultDetail from "edu_lms_v2/modules/TeachingManager/ClassroomManager/ListExerciseResultDetail";
import HistoryExam from "edu_lms_v2/modules/HistoryExam";
import ViewDetail from "edu_lms_v2/modules/DetailTraining/ViewDetail";
import ViewAllDetail from "edu_lms_v2/modules/DetailTraining/ViewAllDetail";
import News from "edu_lms_v2/modules/News";
import Classroom from "edu_lms_v2/modules/Classroom";
import ClassroomDetail from "edu_lms_v2/modules/Classroom/ClassroomDetail";
import { HistoryQuiz } from "edu_lms_v2/modules/Training/HistoryQuiz";
import UpdateInformationTraining from "edu_lms_v2/modules/Training/TrainingTest/UpdateInformation";
import { VerifyEmailWrapper } from "edu_lms_v2/modules/VerifyEmailWrapper";
import TrackingLinkRedirect from "edu_lms_v2/modules/TrackingLinkRedirect";
import RedirectLink from "edu_lms_v2/modules/RedirectLink";
import TestGame from "edu_lms_v2/modules/TestGame";
import DashboardTraining from "edu_lms_v2/modules/DashBoardTraining";
import PublisherList from "edu_lms_v2/modules/PublisherList";
import { onResultUserInfo } from "edu_lms/modules/selection";
import DashboardEvent from "edu_lms_v2/modules/DashBoardEvent";
import Knowledge from "edu_lms_v2/modules/Blog/Knowledge/Knowledge ";
import KnowledgeSubject from "edu_lms_v2/modules/Blog/KnowledgeSubject";
import KnowledgeDetail from "edu_lms_v2/modules/Blog/ViewDetail/KnowledgeDetail";
import KnowledgeNewsPost from "edu_lms_v2/modules/Blog/KnowledgeNewsPost";
import OtherKnowledge from "edu_lms_v2/modules/Blog/OtherKnowledge";
import ViewDetailOther from "edu_lms_v2/modules/Blog/ViewDetailOther";
import BookAppraisal from "edu_lms_v2/modules/BookAppraisal";
import GuideTraining from "edu_lms_v2/modules/Training/GuideTraining";
import Course from "edu_lms_v2/modules/Course";

// Page
import PageTuSach from "pages/PageTuSach";
import PageGiaoAn from "pages/PageGiaoAn";
import PageHocLieu from "pages/PageHocLieu";
import PagePresentSlide from "pages/PagePresentSlide";
import MockTestV2 from "../edu_lms_v2/modules/MockTestV2";

const userInfo = onResultUserInfo();

const commonRoutes = [
  {
    path: `${PATH.ROUTE_PATH_V3_SIGN_IN}`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <LoginPage match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_SIGN_IN,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_SIGN_IN}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_MY_STUDY,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <QuestionSetWrapper />,
  },
  {
    path: `${PATH.ROUTE_PATH_CLASSROOM}:idClassroom${PATH.ROUTE_PATH_EXERCISE_CLASSROOL}:questionSetId/:userId`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <HistoryExam match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_CLASSROOM,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Classroom />,
  },
  {
    path: `${PATH.ROUTE_PATH_CLASSROOM}:id`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <ClassroomDetail match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_CLASSROOM}:idClassroom${PATH.ROUTE_PATH_EXERCISE_CLASSROOL}:questionSetId`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <ListExerciseResultDetail match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_QUESTION_SET_V2,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <QuestionLibraryV2 />,
  },
  {
    path: `${PATH.ROUTE_PATH_EXERCISE}/:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ExerciseContainer match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_PRACTIVE}/:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ExerciseContainer match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST}:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ExerciseContainer match={match} />,
  },
];

const hoc10Routes = [
  ...commonRoutes,
  {
    path: PATH.ROUTE_PATH_SIGN_IN_V1,
    exact: true,
    isPrivate: false,
    showHeader: false,
    showFooter: false,
    main: () => <SignInContainer />,
  },
  {
    path: PATH.ROUTE_BOOK_APPRAISAL,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <BookAppraisal />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <MockTestV2 />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST}:subject/:grade`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <MockTestV2 />,
  },
  {
    path: PATH.ROUTE_PATH_SIGN_UP,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <SignUpContainer />,
  },
  {
    path: PATH.ROUTE_PATH_FORGOT_PASSWORD,
    exact: true,
    isPrivate: false,
    showHeader: false,
    showFooter: false,
    main: () => <ForgotPasswordContainer />,
  },
  {
    path: PATH.ROUTE_PATH_VERIFY_OTP_PW,
    exact: true,
    isPrivate: false,
    showHeader: false,
    showFooter: false,
    main: () => <VerifyOtpPwContainer />,
  },
  {
    path: PATH.ROUTE_PATH_CHANGE_PW,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <ChangePwContainer />,
  },
  {
    path: PATH.ROUTE_PATH_FORM_JOB,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <JobContainer />,
  },
  {
    path: PATH.ROUTE_PATH_EDUCATION_PROGRAM,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_BOOK_INTRO}`,
        }}
      />
    ),
  },

  {
    path: `${PATH.ROUTE_PATH_NEWS_TRAINING}:slug`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <ViewDetail match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_NEWS_TRAINING,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <ViewAllDetail match={match} />,
  },
  // {
  //   path: PATH.ROUTE_BLOG_KNOWLEDGE,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <Knowledge match={match} />,
  // },
  // {
  //   path: PATH.ROUTE_BLOG_KNOWLEDGE_OTHER,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <OtherKnowledge match={match} />,
  // },
  // {
  //   path: `${PATH.ROUTE_BLOG_KNOWLEDGE_OTHER}:slug`,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <ViewDetailOther match={match} />,
  // },
  // {
  //   path: `${PATH.ROUTE_BLOG_KNOWLEDGE}:levelType`,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <Knowledge match={match} />,
  // },
  // {
  //   path: `${PATH.ROUTE_BLOG_KNOWLEDGE}:levelType/:classType/:subjectType/:slug`,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <KnowledgeDetail match={match} />,
  // },
  // {
  //   path: `${PATH.ROUTE_BLOG_KNOWLEDGE_NEWS_POST}:slug`,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <KnowledgeNewsPost match={match} />,
  // },
  // {
  //   path: `${PATH.ROUTE_BLOG_KNOWLEDGE}:levelType/:subjectType`,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: ({ match }) => <KnowledgeSubject match={match} />,
  // },
  {
    path: PATH.ROUTE_BLOG_KNOWLEDGE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <Knowledge match={match} />,
  },
  {
    path: PATH.ROUTE_BLOG_KNOWLEDGE_OTHER,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <OtherKnowledge match={match} />,
  },
  {
    path: `${PATH.ROUTE_BLOG_KNOWLEDGE_OTHER}:slug`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => (
      <>
        <Redirect to={{ pathname: match.url.toLowerCase() }} />
        <ViewDetailOther match={match} />
      </>
    ),
  },
  {
    path: `${PATH.ROUTE_BLOG_KNOWLEDGE}:levelType`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <Knowledge match={match} />,
  },
  {
    path: `${PATH.ROUTE_BLOG_KNOWLEDGE}:levelType/:classType/:subjectType/:slug`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => (
      <>
        <Redirect to={{ pathname: match.url.toLowerCase() }} />
        <KnowledgeDetail match={match} />
      </>
    ),
  },
  {
    path: `${PATH.ROUTE_BLOG_KNOWLEDGE_NEWS_POST}:slug`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <KnowledgeNewsPost match={match} />,
  },
  {
    path: `${PATH.ROUTE_BLOG_KNOWLEDGE}:levelType/:subjectType`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <KnowledgeSubject match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_NEWS,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <News match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_CONTACT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <ContactContainer />,
  },
  {
    path: PATH.ROUTE_PATH_TERMS_OF_USE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <TermsOfUseContainer />,
  },
  {
    path: PATH.ROUTE_PATH_PRIVACY_POLICY,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PrivacyPolicyContainer />,
  },
  {
    path: PATH.ROUTE_PATH_V2_INTRO,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_INTRO}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_BOOK_INTRO,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_BOOK_INTRO}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_ONEPERCENT_INTRO,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_ONEPERCENT_INTRO}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_LIST_BOOK,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_LIST_SLIDE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_LIST_SLIDE}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V3_LIST_SLIDE_OLD,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_LIST_SLIDE_OLD}:subjectSlug/:gradeSlug`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_LIST_SLIDE_OLD}:subject/:grade/:title/:id`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <RedirectLink />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST_OLD}:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: `${PATH.ROUTE_PATH_TRACKING_LINK_REDIRECT}${PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST_OLD}`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST_OLD}`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  
  {
    path: PATH.ROUTE_PATH_V2_FREQUENT_QUESTION,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_FREQUENT_QUESTION}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_CONTACT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_CONTACT}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_CONTACT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_CONTACT}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_TERM_OF_USE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_TERM_OF_USE}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_PRIVACY_POLICY,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_PRIVACY_POLICY}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_UPDATEINFORMATION,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_UPDATEINFORMATION}`,
        }}
      />
    ),
  },
  // {
  //   path: PATH.ROUTE_PATH_V2_REGISTER,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => (
  //     <Redirect
  //       to={{
  //         pathname: `${PATH.ROUTE_PATH_V3_REGISTER}`,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   path: PATH.ROUTE_PATH_V2_TEACHER,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => (
  //     <Redirect
  //       to={{
  //         pathname: `${PATH.ROUTE_PATH_V3_TEACHER}`,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   path: PATH.ROUTE_PATH_V2_STUDENT,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => (
  //     <Redirect
  //       to={{
  //         pathname: `${PATH.ROUTE_PATH_V3_STUDENT}`,
  //       }}
  //     />
  //   ),
  // },

  {
    path: PATH.ROUTE_PATH_V2_TEACHER,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_TEACHER}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_V2_STUDENT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_STUDENT}`,
        }}
      />
    ),
  },
  // {
  //   path: PATH.ROUTE_PATH_V2_REGISTER,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => (
  //     <Redirect
  //       to={{
  //         pathname: `${PATH.ROUTE_PATH_V3_REGISTER}`,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   path: PATH.ROUTE_PATH_V2_TEACHER,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => (
  //     <Redirect
  //       to={{
  //         pathname: `${PATH.ROUTE_PATH_V3_TEACHER}`,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   path: PATH.ROUTE_PATH_V2_STUDENT,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => (
  //     <Redirect
  //       to={{
  //         pathname: `${PATH.ROUTE_PATH_V3_STUDENT}`,
  //       }}
  //     />
  //   ),
  // },
  {
    path: PATH.ROUTE_PATH_GENERAL,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_BOOK_USED,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_LIST_BOOK_TEACHER,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_LIST_BOOK_DOCUMENT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_LIST_WORK_BOOK,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: `${PATH.ROUTE_PATH_BOOK_DETAIL}/:name/:bookType/:id/:pageId`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <BookDetailContainer match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_READING_BOOKS}/:name/:bookType/:id/:pageId`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ReadingBooksContainer match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_READING_BOOKS}/:name/:bookType/:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ReadingBooksContainer match={match} />,
  },

  {
    path: `${PATH.ROUTE_PATH_READING_SLIDE_LIBRARY}/:name/:id`,
    isPrivate: true,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ReadingSlideLibraryContainer match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_READING_SLIDE_LIBRARY}/:id`,
    isPrivate: true,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ReadingSlideLibraryContainer match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_BOOK_INSTRUCTION}/:name/:id`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <BookIntroduceContainer match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_TUTORIAL,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <TutorialContainer />,
  },
  {
    path: `${PATH.ROUTE_PATH_LIST_STUDENT_DOING_HOMEWORK}:id`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <ListStudentDoingHomeWork />,
  },
  {
    path: PATH.ROUTE_INSTRUCTION_ACTIVATED_BOOK,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_FREQUENT_QUESTION}`,
          search: `?q=${menu[1].item[0].slug}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_BOOK_ACTIVATION_INSTRUCTIONS,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_V3_FREQUENT_QUESTION}`,
          search: `?q=${menu[1].item[0].slug}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_PATH_PROGRAMME_GDPT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <ProgrammerContainer />,
  },
  {
    path: PATH.ROUTE_PATH_INTRODUCE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <IntroduceContainer />,
  },
  {
    path: PATH.ROUTE_PATH_EDUCATION_TEACHER,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <EducationTeacherContainer />,
  },

  {
    path: PATH.ROUTE_PATH_SLIDE_LIBRARY,
    isPrivate: true,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <SlideLibraryContainer />,
  },
  {
    path: PATH.ROUTE_PATH_VERIFY_EMAIL,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <VerifyEmailWrapper />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST_5,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <ResultQuestion />,
  },

  {
    path: `${PATH.ROUTE_PATH_QUESTION}/:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <QuestionContainer match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_TRAINING_TEST,
    isPrivate: true,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <TrainingTestContainer />,
  },
  {
    path: PATH.ROUTE_PATH_TRAINING_TEST_2,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <TrainingTestContainer match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_LIST_QUIZ,
    isPrivate: true,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <ListQuizContainer />,
  },
  {
    path: PATH.ROUTE_PATH_LIST_HISTORY_QUIZ,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <HistoryQuiz />,
  },
  {
    path: `${PATH.ROUTE_PATH_LIST_QUIZ_DETAIL}/:gradeId/:subjectId/:quizId`,
    isPrivate: true,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ListQuizDetailContainer match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_ELECTRONIC_COURSEWARE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
        }}
      />
    ),
  },
  {
    path: PATH.ROUTE_UPDATE_INFORMATION,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <UpdateInformationContainer match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_UPDATE_PASSWORD,
    isPrivate: true,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <UpdateInformationContainer match={match} />,
  },
  {
    path: PATH.ROUTE_PATH_DOWNLOAD,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => (
      <Redirect
        to={{
          pathname: `${PATH.ROUTE_PATH_TU_SACH}`,
          search: "?block=3&grade=13&subject=61",
        }}
      />
    ),
  },
  // TODO: Remove these dashboard routers
  // BEGIN: Dashboard
  {
    path: PATH.ROUTE_PATH_DASHBOARD,
    isPrivate: true,
    exact: false,
    showHeader: true,
    showFooter: true,
    main: (props) => <DashboardContainer {...props} />,
    routes: [
      {
        path: PATH.ROUTE_PATH_DASHBOARD,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],
        main: () => <Dashboard />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_PROVINCE,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1],
        main: () => <ResultQuizProvinceContainer />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_DISTRICT,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2],

        main: ({ match }) => <ResultQuizDistrictContainer match={match} />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_SCHOOL,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2],
        main: ({ match }) => <ResultQuizSchoolContainer match={match} />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_TEACHER,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: ({ match }) => <ResultQuizTeacherContainer match={match} />,
      },
      {
        path: `${PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_DISTRICT}/:provinceId/:districtId/:schoolId/:userId/:roleId`,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2],

        main: ({ match }) => <ResultQuizDetailContainer match={match} />,
      },
      {
        path: `${PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_SCHOOL}/:provinceId/:districtId/:schoolId/:userId/:roleId`,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: ({ match }) => <ResultQuizDetailContainer match={match} />,
      },
      {
        path: `${PATH.ROUTE_PATH_DASHBOARD_RESULT_QUIZ_TEACHER}/:provinceId/:districtId/:schoolId/:userId/:roleId`,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: ({ match }) => <ResultQuizDetailContainer match={match} />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_ADMIN_DEPARTMENT_EDUCATION,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1],

        main: () => <AdminDepartmentEducationContainer />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_ADMIN_SCHOOL,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2],

        main: () => <AdminSchoolContainer />,
      },
      {
        path: `${PATH.ROUTE_PATH_DASHBOARD_ADMIN_SCHOOL}/:provinceId/:districtId/:schoolId/:userId/:roleId`,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2],

        main: () => <AdminDetailContainer />,
      },
      {
        path: `${PATH.ROUTE_PATH_DASHBOARD_ADMIN_TEACHER}/:provinceId/:districtId/:schoolId/:userId/:roleId`,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: () => <AdminDetailContainer />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_ADMIN_GRADE,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: () => <AdminGradeContainer />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_ADMIN_TEACHER,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: () => <AdminTeacherContainer />,
      },
      {
        path: PATH.ROUTE_PATH_DASHBOARD_ADMIN_STUDENT,
        accept: true,
        isPrivate: true,
        exact: true,
        showHeader: false,
        showFooter: false,
        roleId: [1, 2, 3],

        main: () => <AdminStudentContainer />,
      },
    ],
  },
  // END: Dashboard
  {
    title: "Giới thiệu",
    path: PATH.ROUTE_PATH_V3_INTRO,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Intro />,
  },
  {
    path: PATH.ROUTE_PATH_TU_SACH,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PageTuSach />,
  },
  {
    path: `${PATH.ROUTE_PATH_TU_SACH}doc-view-page`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <PagePresentSlide />,
  },
  {
    path: `${PATH.ROUTE_PATH_TU_SACH}:subject/:grade`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PageTuSach />,
  },
  {
    path: PATH.ROUTE_PATH_COURSE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PageHocLieu />,
  },
  {
    path: `${PATH.ROUTE_PATH_COURSE}:subject/:grade`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PageHocLieu />,
  },
  // {
  //   path: `${PATH.ROUTE_PATH_ELECTRONIC_COURSEWARE_V2}:grade/:subject`,
  //   accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => <PageTuSach />,
  // },
  {
    path: `${PATH.ROUTE_PATH_ELECTRONIC_COURSEWARE_V2}:grade/:subject/video/:slugvideo`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PageTuSach />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Student />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_DOING_EXERCISE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <StudentDoingExercise />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_DOING_EXERCISE_2,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <StudentDoingExercise2 />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_DOING_EXERCISE_3,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <StudentDoingExercise3 />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_DOING_EXERCISE_4,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <StudentDoingExercise4 />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_DOING_EXERCISE_5,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <StudentDoingExercise5 />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_DOING_EXERCISE_6,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <StudentDoingExercise6 />,
  },
  {
    path: PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST_2,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <MockTest2 />,
  },
  {
    path: PATH.ROUTE_PATH_V3_TEACHER,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Teacher />,
  },
  {
    path: PATH.ROUTE_PATH_V3_REGISTER,
    isPrivate: false,
    showHeader: false,
    showFooter: false,
    main: () => <Register />,
  },
  {
    path: PATH.ROUTE_PATH_V3_UPDATEINFORMATION,
    accept: !(userInfo?.test_book_3_7_10 && !userInfo?.is_user_hoc10),
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <UpdateInformation />,
  },
  {
    path: PATH.ROUTE_PATH_V3_TEACHER_LIST_EXERCISE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <TeacherExerciseList />,
  },
  {
    path: PATH.ROUTE_PATH_V2_NOTIFICATION,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Notification />,
  },

  {
    path: PATH.ROUTE_PATH_V3_CONTACT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PrivacyPolicy />,
  },
  {
    path: PATH.ROUTE_PUBLISHER_LIST,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PublisherList />,
  },
  {
    path: PATH.ROUTE_PATH_LIST_HISTORY_QUIZ,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <UpdateInformationTraining />,
  },
  {
    path: PATH.ROUTE_PATH_V3_TERM_OF_USE,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Term />,
  },
  {
    path: PATH.ROUTE_PATH_V3_PRIVACY_POLICY,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Privacy />,
  },
  {
    path: PATH.ROUTE_PATH_V3_TRAINING,
    accept: !(userInfo?.test_book_3_7_10 && !userInfo?.is_user_hoc10),
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <HistoryQuiz />,
  },
  {
    path: PATH.ROUTE_DASHBOARD_TRAINING,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <DashboardTraining />,
  },
  {
    path: PATH.ROUTE_GUIDE_TRAINING,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <GuideTraining />,
  },
  {
    path: PATH.ROUTE_DASHBOARD_EVENT,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <DashboardEvent />,
  },
  {
    path: PATH.ROUTE_PATH_V2_SETTING,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Setting />,
  },
  {
    path: PATH.ROUTE_PATH_V3_ONEPERCENT_INTRO,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <OnePercentIntro />,
  },
  // {
  //   path: PATH.ROUTE_PATH_V2_AUTHOR_INTRO,
  // accept: true,
  //   isPrivate: false,
  //   exact: true,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => <AuthorIntro />,
  // },
  // {
  //   path: `${PATH.ROUTE_PATH_V2_AUTHOR_DEATAIL}:id`,
  // accept: true,
  //   isPrivate: false,
  //   exact: false,
  //   showHeader: true,
  //   showFooter: true,
  //   main: () => <AuThor />,
  // },
  {
    path: PATH.ROUTE_PATH_V3_BOOK_INTRO,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <BookIntro />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_LIST_SLIDE}`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <PageGiaoAn />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_LIST_SLIDE}:subjectSlug/:gradeSlug`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <PageGiaoAn match={match} />,
  },

  {
    path: `${PATH.ROUTE_PATH_V3_LIST_SLIDE}:subject/:grade/:title/:id`,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: ({ match }) => <ReadingSlide match={match} />,
  },
  {
    path: `${PATH.ROUTE_PATH_V3_FREQUENT_QUESTION}`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: ({ match }) => <FrequentQuestion match={match} />,
  },
  {
    title: "Trang chủ",
    path: PATH.ROUTE_PATH_V2_HOME,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <Home />,
  },
  {
    path: PATH.ROUTE_PATH_TRACKING_LINK_REDIRECT,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <TrackingLinkRedirect />,
  },
  {
    path: `${PATH.ROUTE_PATH_TRACKING_LINK_REDIRECT}${PATH.ROUTE_PATH_V3_STUDENT_MOCK_TEST}`,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <MockTestV2 />,
  },
  {
    path: PATH.ROUTE_REDIRECT_LINK_GRADE_4,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: PATH.ROUTE_REDIRECT_LINK_GRADE_8,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: PATH.ROUTE_REDIRECT_LINK_GRADE_11,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: PATH.ROUTE_REDIRECT_LINK_GRADE_5,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: PATH.ROUTE_REDIRECT_LINK_GRADE_9,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: PATH.ROUTE_REDIRECT_LINK_GRADE_12,
    isPrivate: false,
    exact: true,
    showHeader: false,
    showFooter: false,
    main: () => <RedirectLink />,
  },
  {
    path: PATH.ROUTE_TEST_GAME,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <TestGame />,
  },
  {
    path: PATH.ROUTE_PATH_NOT_FOUND,
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <NotFoundContainer />,
  },
  {
    path: "",
    isPrivate: false,
    exact: true,
    showHeader: true,
    showFooter: true,
    main: () => <NotFoundContainer />,
  },
];

export default hoc10Routes;
